import type { SecondaryOrderStatePath } from 'state/secondaryMarket/secondaryMarket.model';
import { formSelectorsFactory } from 'state/secondaryMarket/shared/form/form.selector';
import type { AppState } from 'state/state.model';

export const formOriginalSelectorsFactory = <S>(
  stateType: Exclude<SecondaryOrderStatePath, 'cpOrder'>,
  selectors: S,
) => {
  const select = (state: AppState, tabId: string) => state.secondaryMarket[stateType].form.original[tabId];
  return {
    getEtag: (state: AppState, tabId: string) => select(state, tabId)?.etag,
    isLoaded: (state: AppState, tabId: string) => select(state, tabId) !== undefined,
    getPriceType: (state: AppState, tabId: string) => select(state, tabId)?.priceType,
    ...formSelectorsFactory(stateType, 'original', selectors),
  };
};
